export default [
  /** 个人中心 开始 */
  {
    path: '/user/points',
    name: 'points',
    component: () => import(/* webpackChunkName: "points" */ '../../views/user/Points.vue'),
    meta: {
      title: '积分明细',
    },
  },
  /** 个人中心 结束 */
]
